import React, { Component } from "react";
// import Layout from "@pages/candidate/Layout";
import {
    Heading,
    Container,
    Box,
    Flex,
    Center,
    Divider,
    Avatar,
    Text,
    Image,
    VStack,
    HStack,
    FormLabel,
    Button,
    Spacer,
    ButtonGroup,
    IconButton,
    Input,
    Spinner,
    Link as A
} from "@chakra-ui/react";

import Layout from "@pages/Layout";
import { Separator, View, ToggleSwitch, BoxData, ModalBox, PreviewPdf } from '@components';
import { IconVideo, IconPicture, PlayStore, AppStore, IconPDF, IconImage, IconAvatar, IconEdit, IconDelete, IconSuccess } from "@assets/Icons";
import { getInfo, setVisibility, setSettings, upload_img_profile, upload_cv, delete_cv } from "@lib/datahandlers/person";
import { t } from '@lang/i18n';
import { AuthContext } from '@contexts/AuthContext';
import { Link } from "react-router-dom";
class ProfileScreen extends Component {
    static contextType = AuthContext;

    state = {
        loading: false,
        user: {},
        pdf: "",
        image: "",
        cv: "",
        file: "",
        picture: "",
        showModalBox: false,
        showPDF: false,
        loading_cv: false,
        loading_img: false
    };

    componentDidMount() {
        document.title = t('candidate.profile.main.page_title');
        this.getInfo();
    }

    getInfo = async () => {
        this.setState({ loading: true });
        const response = await getInfo();
        this.setState({ loading: false });

        if (response) this.setState({ user: response.user });
    };
    setVisibility = async (e) => {
        let visible = e.target.checked;
        this.state.user.person.visible = visible;
        this.setState({user: this.state.user});
        const success = await setVisibility(visible);
        if(!success) {
            this.state.user.person.visible = !visible;
            this.setState({user: this.state.user});
            this.context.toast({description: t('global.general_error'), status: "warning", variant: 'subtle', duration: 3000})
        }
    };
    setSettings = async (e, type) => {
        let notif = e.target.checked;
        this.state.user['notif_'+type] = notif;
        this.setState({user: this.state.user});

        const success = await setSettings({
            notif_push: this.state.user.notif_push,
            notif_mail: this.state.user.notif_mail,
            ['notif_'+type]: notif
        });
        if(!success) {
            this.state.user['notif_'+type] = !notif;
            this.setState({user: this.state.user});
            this.context.toast({description: t('global.general_error'), status: "warning", variant: 'subtle', duration: 3000})
        }
    };
    uploadCV = async (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        this.setState({
            loading_cv: true
        })
        try {
            const reader = new FileReader();

            reader.onloadend = () => {
                this.setState({
                    file: file,
                    cv: reader.result,
                })
            };
            reader.readAsDataURL(file);
        } catch (err) {
            console.log("fileReader: ", err);
        }

        // upload img to server
        const formData = new FormData();
        formData.append("CV", file);

        const result = await upload_cv(formData);
        console.log('result: ', result)
        if (result.success) {
            this.setState({
                user: result.data.user,
                loading_cv: false
            })
            return;
        }
        this.setState({ loading_cv: false });
        this.context.toast({description: "Le champ cv doit être un fichier de type : jpeg, jpg, png, bmp, pdf.", status: "error", variant: 'left-accent', duration: 3000});
    };
    uploadImageProfile = async (e) => {
        e.preventDefault();
        this.setState({ loading_img: true });
        
        const file = e.target.files[0];
        try {
            const reader = new FileReader();

            reader.onloadend = () => {
                this.setState({
                    file: file,
                    image: reader.result,
                })
            };
            reader.readAsDataURL(file);
        } catch (err) {
            console.log("fileReader: ", err);
        }

        // upload img to server
        const formData = new FormData();
        formData.append("picture", file);

        try {
            const result = await upload_img_profile(formData);
            if (result.success) {
                this.setState({
                    picture: result.data.user.picture,
                    user: result.data.user,
                    loading_img: false
                })
                return;
            }
        } catch (err) {
            console.log(err.message);
        }
    };
    deleteCV = async () => {
        const result = await delete_cv();
        if (result.success) {
            this.setState({
                user: result.data.user,
                showModalBox: false
            })
            return;
        }
    };

    isMobileTablet = () => {
        let check = false;
        (function(a){
            if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) 
                check = true;
        })(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };
    getFileExtension = (filename) => {
        return filename && filename.split('.').pop();
    };
    isAndroid = () => {
        return navigator.userAgent.toLowerCase().indexOf("android") > -1
    };
    

    render() {
        let user = this.state.user;
        let picture = null;
        if (this.state.picture) picture = this.state.picture;
 
        let search_radius;
        if(user.person) {
            // set radius
            search_radius = user.person.search_radius;
            if(search_radius === 101 || search_radius === 999) search_radius = '+100Km';
            else if(search_radius === 0) search_radius = t('candidate.search_job.main.Indifferent');
            else search_radius += 'Km';
        }
        // to avoid errors while loading user info (i don't like using "?." too much)
        else user = {person: {fonctions:[], preferred_contracts:[], activities: [], contracts:[], experience:{}, situation:{}, relationship_status:{}}}

        return (
            <Layout menuType="candidate" isNavBarVisible isFooterVisible>
                <View if={this.state.showModalBox}>
                    <ModalBox isOpen={this.state.showModalBox}>
                        <View mb="30px">
                            <IconSuccess iconType="candidate" />
                        </View>
                        <Text color="black" textAlign="center" fontSize="20px" fontWeight="600">
                            {t("messages.popup.delete_msg")}
                        </Text>

                        <ButtonGroup spacing="6">
                            <Button bg="white" border="2px solid" borderRadius="24px" color="blue.dark" borderColor="blue.dark" w="150px" py="20px" mt="26px"
                                    _hover={{ bg: "white", opacity: ".7" }}
                                    onClick={() => this.setState({ showModalBox: false })}
                                >
                                {t("global.close")}
                            </Button>
                            <Button bg="blue.dark" border="2px solid" borderColor="blue.dark" borderRadius="24px" color="white" w="150px" py="20px" mt="26px"
                                _hover={{ bg: "blue.dark", opacity: ".7" }}
                                onClick={() => this.deleteCV()}
                            >
                                {t("global.delete")}
                            </Button>
                        </ButtonGroup>
                    </ModalBox>
                </View>
                
                <Container maxW="1024px" bg="white" minHeight='calc(100vh - 100px)' py="36px" px={["16px", "", "", "100px"]} borderRadius="4px">
                    <Flex flexDir="column" backdropBlur="blur(10px)" opacity=".9">

                        <Heading textAlign="center" fontSize="30px" m="auto" maxW="435px"> {t('candidate.profile.main.title')} </Heading>
                        <Separator />

                        <Flex flexDir="row" flexWrap="wrap-reverse" justifyContent="space-around" alignItems="center">
                            <Box
                                pos="relative"
                                w="348px" 
                                maxH="640px"
                                borderRadius="3px"
                                display="flex"
                                flexDir="column"
                                justifyContent="center"
                                alignItems="center">

                                {/* Video player */}
                                <View if={user.person.video && this.state.play} pos="relative">
                                    <video 
                                        autoPlay={true}
                                        style={{height:"100%", minHeight:"640px"}}
                                        onEnded={() => this.setState({play: false})}
                                        controls={true}>
                                        <source src={user.person.video} type="video/mp4" />
                                    </video>
                                </View>

                                {/* Thumbnail */}
                                <View if={user.person.video && !this.state.play} pos="relative" overflow="hidden" rounded="sm" boxShadow="base">
                                    <Image src={user.person.thumbnail} minH="640px" alt="thumbnail" />
                                    <Box
                                        borderRadius="99px"
                                        pos="absolute"
                                        top="50%"
                                        left="50%"
                                        zIndex="100"
                                        cursor="pointer"
                                        _hover={{opacity: .8}}
                                        onClick={e=>this.setState({play: true})}
                                        transform="translate(-50%,-50%)">
                                        <IconVideo iconAction="play" iconType="candidate"/>
                                    </Box>
                                </View>

                                {/* No video */}
                                <View if={!user.person.video} 
                                    display="flex"
                                    alignItems="center"
                                    h="100%" w="100%"
                                    style={{/*dashed border*/backgroundImage: "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23333' stroke-width='2' stroke-dasharray='4,8' stroke-dashoffset='6' stroke-linecap='square'/%3e%3c/svg%3e\")"}}
                                    rounded="md"
                                    borderColor="#979797">
                                    <Flex flexDir="column" justifyContent="center" alignItems="center" w="100%" h="619px" >
                                        <Box mx="auto" mb="20px">
                                            <IconVideo iconType="candidate" iconAction="add" />
                                        </Box>
                                        <Text
                                            mx="auto"
                                            maxW="250px"
                                            fontSize="14px"
                                            fontWeight="700"
                                            textAlign="center"
                                            color="blue.main">
                                            {t("candidate.profile.main.add_video")}
                                        </Text>
                                        <HStack alignItems="center" justifyContent="center" mt="40px" overflow="hidden">
                                            <A style={{display:'flex', flex: 1, justifyContent:'flex-end'}} target="_blank" href="https://apps.apple.com/fr/app/visiojob/id1469233218">
                                                <Image h="40px" src={AppStore} />
                                            </A>
                                            <Spacer flex="0" w="10px" />
                                            <A style={{position:'relative', flex: 1, justifyContent:'flex-start'}} target="_blank" href="https://play.google.com/store/apps/details?id=com.pistonnemoi.pistonnemoi">
                                                <Image h="40px" src={PlayStore} />
                                            </A>
                                        </HStack>
                                    </Flex>
                                </View>

                                {/* upload cv */}
                                <View if={!user.person.CV}
                                    h="42px" w="100%" mt="35px" 
                                    style={{/*dashed border*/backgroundImage: "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23333' stroke-width='2' stroke-dasharray='4,8' stroke-dashoffset='6' stroke-linecap='square'/%3e%3c/svg%3e\")"}}>
                                    <HStack h="100%" justifyContent="center" alignItems="center" py="10px">
                                        <FormLabel my="0" htmlFor="file-pdf" _hover={{ cursor: "pointer"}}>
                                            <Image cursor="pointer" _hover={{opacity:.8}} src={IconPDF} />
                                            <Input type="file" id="file-pdf" onChange={this.uploadCV} display="none" />
                                        </FormLabel>

                                        <FormLabel my="0" htmlFor="file-image">
                                            <Image cursor="pointer" _hover={{opacity:.8}} src={IconImage} />
                                            <Input type="file" id="file-image" onChange={this.uploadCV} display="none" />
                                        </FormLabel>
                                        <Text cursor="default" fontWeight="bold" fontSize="14px" color="blue.main">
                                            { this.state.loading_cv? <Spinner size="md" /> : t("candidate.profile.main.add_cv") }
                                        </Text>
                                    </HStack>
                                </View>
                                
                                {/* cv (preview - edit - delete) */}
                                <View if={user.person.CV}
                                    h="42px" w="100%" mt="35px" 
                                    display="flex" justifyContent="center" alignItems="center"
                                    boxShadow="0px 1px 3px rgba(129, 129, 129, 0.5)" borderRadius="5px">
                                    <Flex justifyContent="center" alignItems="center" py="10px" w="263px" onClick={() => this.setState({showPDF: true})}>
                                        <Image cursor="pointer" _hover={{opacity:.8}} src={IconPDF} />
                                        <Text cursor="default" fontWeight="bold" fontSize="14px" color="blue.main" ml=".5rem">
                                            { this.state.loading_cv? <Spinner size="md" /> : t("candidate.profile.main.check_cv") }
                                        </Text>
                                    </Flex>

                                    <PreviewPdf file={user.person.CV} showPDF={this.state.showPDF} setShowPDF={() => this.setState({showPDF: false})} />

                                    <EditDeleteCv upload={this.uploadCV} showModal={() => this.setState({ showModalBox: true })} />           
                                </View>
                            </Box>

                            <Center height="30rem" m="78px 0" display={["none", "", "block"]}>
                                <Divider orientation="vertical" borderLeft=".5px solid #888" h="30rem" />
                            </Center>

                            <Flex flexDir="column" ml={["", "", "16px", ""]} mb="2rem">
                                <Flex flexDir={["column", "", "row"]} alignItems="center" justifyContent="center">
                                    
                                    <EditPicture data={picture? picture : user.picture} upload={this.uploadImageProfile} loading={this.state.loading_img} />
                                    
                                    <Text color="black" fontWeight="700" fontSize="20px" ml={["", "", "1rem", ""]}>
                                        {`${user?.person?.first_name} ${user?.person?.last_name}`}
                                    </Text>
                                </Flex>

                                <VStack flexDir="column" mt="32px" mb="54px" w="294px">
                                    <AttrValue attr={t("fields.company.birth_date")}            val={user.person.birthday && user.person.birthday + " " + "(" + user.person.age + " ans)"}/>
                                    <AttrValue attr={t("fields.company.address")}               val={user.address}/>
                                    <AttrValue attr={t("fields.company.rayon_search")}          val={search_radius && search_radius } />
                                    <AttrValue attr={t("fields.company.situation")}             val={user.person.situation && user.person.situation.name} />
                                    <AttrValue attr={t("fields.company.metier")}                val={user.person.fonctions && user.person.fonctions } type="array"/>
                                    <AttrValue attr={t("fields.candidates.activities")}  val={user.person.activities && user.person.activities } type="array" />
                                    <AttrValue attr={t("fields.company.contract")}              val={user.person.preferred_contracts && user.person.preferred_contracts } type="array"/>
                                    <AttrValue attr={t("fields.company.experience")}            val={user.person.experience && user.person.experience.name } />
                                    <AttrValue attr={t("company.candidate_cv.phone")}           val={user.phone}/>
                                    <AttrValue attr={t("company.candidate_cv.email")}           val={user.email}/>
                                    <AttrValue attr={t("fields.company.civil_status")}          val={user.person.relationship_status && user.person.relationship_status.name }/>
                                    <AttrValue attr={t("fields.company.has_permis")}            val={user.person.driving_license && user.person.driving_license } type="bool"/>
                                    <AttrValue attr={t("fields.company.has_vehicule")}          val={user.person.has_vehicle && user.person.has_vehicle } type="bool"/>
                                    <AttrValue attr={t("fields.company.handicap")}              val={user.person.has_handicap && user.person.has_handicap } type="bool"/>
                                    <AttrSwitch attr={t("candidate.profile.main.interested_opportunities")} val={user.person.visible} onChange={this.setVisibility} />
                                    <AttrSwitch attr={t("company.profile.main.push_notif")}  val={user.notif_push} onChange={e=>this.setSettings(e, 'push')} />
                                    <AttrSwitch attr={t("company.profile.main.email_notif")} val={user.notif_mail} onChange={e=>this.setSettings(e, 'mail')} />
                                    
                                    <Flex flexDir="column" alignItems="center">
                                        <Link to={'/candidate/profile/edit-profile'}>
                                            <Button w={["60vw", "", "345px", ""]} h="40px" mt="30px !important" mb="16px"
                                                borderRadius="99px" bg="blue.main"
                                                boxShadow="0px 1px 3px rgba(129, 129, 129, 0.5)"
                                                color="white" cursor="pointer"
                                                _hover={{opacity: ".8"}}>
                                                {t("candidate.profile.main.edit_profile")}
                                            </Button>
                                        </Link>

                                        <Link to={'/candidate/profile/reset-password'}>
                                            <Button w={["60vw", "", "345px", ""]} h="40px" mb="30px !important"
                                                borderRadius="99px" bg="blue.main"
                                                boxShadow="0px 1px 3px rgba(129, 129, 129, 0.5)"
                                                color="white" cursor="pointer"
                                                _hover={{opacity: ".8"}}>
                                                {t("candidate.profile.main.edit_password")}
                                            </Button>
                                        </Link>
                                    </Flex>
                                </VStack>
                            </Flex>
                        </Flex>
                    </Flex>                
                </Container>
            </Layout>
        )
    }
}

const AttrValue = ({attr, val, type}) => {
    return (
        <Box fontSize="14px" pb="4px" mt="4px !important" borderBottom=".5px solid #EEE" w="100%">
            <Box as="span" fontWeight="300" color="gray.borders">{attr} : </Box>
            <Box as="span" ml=".2rem">
                {type==='array' && <BoxData data={val?.map(e=>e.name).join(', ')} />}
                {type==='bool'  && <BoxData data={val === null? null : val === 1? t('global.yes') : t('global.no') } />}
                {!type && <BoxData data={val} />}
            </Box>
        </Box>
    )
};

const AttrSwitch = ({attr, val, onChange}) => {
    return (
        <HStack w="100%" justifyContent="space-between" alignItems="center">
            <FormLabel cursor="pointer" fontSize="14px" fontWeight="600" w="160px" htmlFor={attr}>
                {attr}
            </FormLabel>
            <ToggleSwitch
                alignItems="flex-end"
                id={attr}
                onChange={onChange}
                checked={val || false}
                type="candidate"
                />
        </HStack>
    )
};

const EditPicture = ({ data, upload, loading }) => {
    return(
        <Box pos="relative">
            <Avatar src={data ? data : IconAvatar} name="avatar" size="xl" />

            <FormLabel
                m="0 !important"
                border="1px solid"
                borderColor="white"
                w="2.25rem"
                p="5px"
                borderRadius="50%"
                bg="white"
                boxShadow="2px 2px 20px rgba(0, 0, 0, 0.15)"
                pos="absolute"
                bottom="0"
                transform="translate(180%, 0)"
                _hover={{ cursor: "pointer" }}
                htmlFor="file-img-profile"
            >
                { loading ? <Spinner size="md" thickness="3px" display="flex" color="blue.main" /> : <IconPicture iconType="candidate" /> }
                <Input type="file" id="file-img-profile" onChange={upload} display="none" />
            </FormLabel>
        </Box>
    )
};

const EditDeleteCv = ({ upload, showModal }) => {
    return(
        <Flex>
            <FormLabel htmlFor="file-image" _hover={{ cursor: "pointer"}}
                    w="42px" m="0" bg="edit" display="flex" justifyContent="center" py="10px">
                <Image cursor="pointer" _hover={{opacity:.8}} src={IconEdit}  />
                <Input type="file" id="file-image" onChange={upload} display="none" />
            </FormLabel>
            <Box w="42px"  bg="error" display="flex" justifyContent="center" py="10px" borderRightRadius="5px"
                onClick={showModal}>
                <Image cursor="pointer" _hover={{opacity:.8}} src={IconDelete}  />
            </Box>
        </Flex> 
    )
}

export default ProfileScreen;